import React, { Component } from 'react';
import Autosuggest from 'react-autosuggest';
import {
    getSearchList
} from '../API/FetchCall';
class Headsearch extends React.Component {
    constructor() {
        super();
        this.state = {
            suggestions: [],
            value: localStorage.getItem("searchdata") ? localStorage.getItem("searchdata") : '',
            current_location: localStorage.getItem("current_location") ? localStorage.getItem("current_location") : 'bengaluru',
        };
    }


    escapeRegexCharacters(str) {
        return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }


    getSuggestions = async (value) => {
        const escapedValue = this.escapeRegexCharacters(value.trim());
        let list = await this.getSearchListFetch(escapedValue);
        var final = [];
        if (list.status === 1) {
            final = list.list
            this.setState({
                searchList: list.list
            })
        } else {
            final = [];
        }
        return final;
    }
    getSearchListFetch = (val) => {
        let data = JSON.stringify({
            keyword: val,
            city: this.state.current_location,
        })
        return getSearchList(data).then(response => response);
    }
    shouldRenderSuggestions = (value, reason) => {
        return value.trim().length > 2;
    };
    getSuggestionValue(suggestion) {
        return suggestion.name;
    }

    renderSuggestion(suggestion) {
        return (
            <span>{suggestion.name}</span>
        );
    }

    searchLink = (e) => {
        e.preventDefault();

        let search_text = this.state.value;
        if (search_text.length > 3) {
            //console.log('search_text',search_text)
            var search = search_text.split(' ').join('+');
            window.location.replace('/search/' + search);
        }
        // localStorage.setItem("searchdata", search_text);
    }
    onSuggestionsFetchRequested = ({ value }) => {
        this.getSuggestions(value).then(response => {
            this.setState({
                suggestions: response
            });
        })
    };

    onSuggestionsClearRequested = () => {
        this.setState({
            suggestions: []
        });
    };

    onChange = (event, { newValue, method }) => {
        this.setState({
            value: newValue
        });
    };
    render() {
        const { value, suggestions } = this.state;
        const inputProps = {
            placeholder: "",
            value,
            onChange: this.onChange
        };
        return (
            <React.Fragment>
                <div className='searchAndLangWrap cf'>
                    <div className='searchBoxWrap'>
                        <div className='searchBox'>
                            <div className='searchBoxRow cf'>
                                <form onSubmit={this.searchLink}>
                                    <Autosuggest
                                        suggestions={suggestions}
                                        shouldRenderSuggestions={this.shouldRenderSuggestions}
                                        onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                                        onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                                        getSuggestionValue={this.getSuggestionValue}
                                        renderSuggestion={this.renderSuggestion}
                                        inputProps={inputProps} />

                                    <input
                                        type='submit'
                                        name='submit'
                                        id='submit'
                                        title='Click here to search'
                                        className='btn btn-primary searchGo'
                                        value='Go'
                                    />
                                </form>
                            </div>
                        </div>
                    </div>
                </div>

            </React.Fragment>
        )
    }
}
export {
    Headsearch
}